import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale, esLocale, frLocale, ptBrLocale } from 'ngx-bootstrap/locale';

defineLocale('pt', ptBrLocale);
defineLocale('es', esLocale);
defineLocale('fr', frLocale);
defineLocale('en', enGbLocale);
